<template>
    <Bubble :chart-options="chartOptions" :chart-data="chartData" />
</template>

<script>
import { Bubble } from 'vue-chartjs'
import { Chart as ChartJS, Title, Tooltip, Legend, PointElement, LinearScale } from 'chart.js'

ChartJS.register(Title, Tooltip, Legend, PointElement, LinearScale)

export default {
    name: 'BubbleChart',
    components: { Bubble },
    props: {
        chartData: {
            type: Object,
            required: true
        },
        chartOptions: {
            type: Object,
            required: false
        },
    }
}
</script>
